import { course_unitConstants } from '../_constants';

export function course_units(state = {}, action) {
  switch (action.type) {
    case course_unitConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case course_unitConstants.GETALL_SUCCESS:
      return {
        items: action.course_units.data
      };
    case course_unitConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


export function course_unit(state = {}, action) {
  switch (action.type) {
    case course_unitConstants.REGISTER_SUCCESS:
      return {
        item: action.course_unit.data
      };
    case course_unitConstants.GET_REQUEST:
      return {
        loading: true
      };
    case course_unitConstants.GET_SUCCESS:
      return {
        item: action.course_unit.data
      };
    case course_unitConstants.GET_FAILURE:
      return {
        error: action.error
      };
    case course_unitConstants.DELETE_REQUEST:
      return {
        loading: true
      };
    case course_unitConstants.DELETE_SUCCESS:
      return {
        loading: true
      };
    case course_unitConstants.DELETE_FAILURE:
      return {
        loading: true
      };
    default:
      return state
  }
}


export function course_units_sort(state = {}, action) {
  switch (action.type) {
    case course_unitConstants.SORT_REQUEST:
      return {
        loading: true
      };
    case course_unitConstants.SORT_SUCCESS:
      return {
        item: action.sort
      };
    case course_unitConstants.SORT_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}